import { render, staticRenderFns } from "./Layoutone.vue?vue&type=template&id=4054ad0f&scoped=true"
import script from "./Layoutone.vue?vue&type=script&lang=js"
export * from "./Layoutone.vue?vue&type=script&lang=js"
import style0 from "./Layoutone.vue?vue&type=style&index=0&id=4054ad0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4054ad0f",
  null
  
)

export default component.exports